import { Directive, ElementRef, OnInit, Injector, OnDestroy } from '@angular/core';
import { Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { MmSpinningService } from './spinning.service';
import { ComponentPortal } from '@angular/cdk/portal';
import { MmOverlaySpinningComponent } from './components/overlay-spinning';
import { Subject } from 'rxjs';
import { takeUntil, finalize } from 'rxjs/operators';

@Directive({
  selector: '[mm-global-spinning]'
})
export class MmGlobalSpinningDirective implements OnInit, OnDestroy {

  onDestroy$ = new Subject();
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }


  constructor(
    private injector: Injector,
    private elementRef: ElementRef,
    private overlay: Overlay,
    private spinningService: MmSpinningService) {

  }

  ngOnInit(): void {
    var config: OverlayConfig = {
      hasBackdrop: true,
      backdropClass: 'ant-modal-mask',
      scrollStrategy: this.overlay.scrollStrategies.block(),
      positionStrategy: this.overlay.position().global(),
      height: '100%',
      width: '100%'
    };
    const ref = this.overlay.create();
    this.spinningService.count$.pipe(takeUntil(this.onDestroy$)).pipe(
      finalize(() => {
        if (ref.hasAttached()) {
          ref.detach();
        }
      })

    ).subscribe(c => {

      if (c > 0 && !ref.hasAttached()) {
        ref.attach(new ComponentPortal(MmOverlaySpinningComponent, null, this.injector));
      }
      else if (c <= 0 && ref.hasAttached()) {
        ref.detach();
      }
    });

  }

}
